import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import { FormCheckbox } from '@fs/zion-form'
import FormStandardizedSexField from '../../../../standardizedSexField/StandardizedSexField'
import PersonFormElement from '../../shared/PersonFormElement'
import AddInputButton from './AddInputButton'
import ExpandableInput from './ExpandableInput'

export default function ExpandableInputWithAddButton({
  fieldId,
  fieldName,
  fieldType,
  testId,
  displayLabel,
  addText,
  removeText,
  setValue,
  checkboxName,
  checkboxValue,
  hasSelectedHighlights,
}) {
  const [t] = useTranslation()
  const [fieldObj, setFieldObj] = useState()

  return (
    <>
      {!fieldObj && (
        <AddInputButton
          setter={setFieldObj}
          fieldId={fieldId}
          testId={testId}
          label={displayLabel}
          fieldType={fieldType}
          name={fieldName}
          buttonText={addText}
        />
      )}
      {fieldObj && (
        <ExpandableInput
          fieldEl={
            fieldType === 'SEX_CODE' ? (
              <FormStandardizedSexField fieldName={fieldName} addedSexCode={fieldObj} key={fieldObj.id} />
            ) : (
              <PersonFormElement field={fieldObj} showEditHighlight={!checkboxValue} />
            )
          }
          displayLabel={fieldObj.label}
          checkboxEl={
            checkboxName ? (
              <FormCheckbox
                data-testid={`no-highlight-possible-${testId}`}
                label={t('highlight-required-checkbox-label', 'No highlight possible')}
                name={checkboxName}
                disabled={hasSelectedHighlights(fieldId)}
              />
            ) : null
          }
          onDelete={() => {
            setFieldObj(null)
            setValue(fieldName, '')
          }}
          removeText={removeText}
          testId={testId}
        />
      )}{' '}
    </>
  )
}
